import { createSlice } from "@reduxjs/toolkit";

export const transactionSlice = createSlice({
    name: 'transaction',
    initialState: {

    }, 
    reducers: {
        transactionData : (state, action) => {
            state.payload = action.payload
        }
    }
});

export const {transactionData} = transactionSlice.actions;
export default transactionSlice.reducer;